export default __webpack_public_path__ + "static/media/office-castro.caa95358.jpg";